import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "blog-details-wrap pt-20 pb-20" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row gx-5" }
const _hoisted_4 = { class: "col-xl-8 col-lg-12" }
const _hoisted_5 = {
  key: 0,
  class: "post-img"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "text-center"
}
const _hoisted_8 = {
  key: 1,
  class: "post-img"
}
const _hoisted_9 = {
  key: 0,
  class: "youtube-video"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "post-metainfo list-style" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-user" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-calendar" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-bubble-chat" }),
  /*#__PURE__*/_createTextVNode("Aucun commentaire")
], -1)
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "blog-card style1" }
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "blog-img" }
const _hoisted_20 = ["src"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "mb20" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://tawk.to/lapostebenineservice",
    target: "_blank",
    class: "btn btn-sm style1"
  }, "Discuter avec un agent de La Poste du Bénin")
], -1)
const _hoisted_22 = {
  key: 0,
  class: "post-meta-option"
}
const _hoisted_23 = { class: "row gx-0 align-items-center" }
const _hoisted_24 = { class: "col-md-7 col-12" }
const _hoisted_25 = { class: "post-tag" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-supermarket" }),
  /*#__PURE__*/_createTextVNode("Tags:")
], -1)
const _hoisted_27 = { class: "tag-list list-style" }
const _hoisted_28 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-5 col-12 text-md-end text-start\"><div class=\"post-share w-100\"><span>Réseaux Sociaux:</span><ul class=\"social-profile style2 list-style\"><li><a target=\"_blank\" href=\"https://facebook.com\"><i class=\"ri-facebook-fill\"></i></a></li><li><a target=\"_blank\" href=\"https://twitter.com\"><i class=\"ri-twitter-fill\"></i></a></li><li><a target=\"_blank\" href=\"https://linkedin.com\"><i class=\"ri-linkedin-fill\"></i></a></li><li><a target=\"_blank\" href=\"https://instagram.com\"><i class=\"ri-pinterest-fill\"></i></a></li></ul></div></div>", 1)
const _hoisted_29 = { class: "col-xl-4 col-lg-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ViewArticleSidebar = _resolveComponent("ViewArticleSidebar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            (_ctx.article?.urlImage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_ctx.article?.urlImage)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.getUrlApiForFiles(_ctx.article.urlImage),
                        alt: "Image"
                      }, null, 8, _hoisted_6))
                    : (_openBlock(), _createElementBlock("p", _hoisted_7, "Aucune image"))
                ]))
              : _createCommentVNode("", true),
            (_ctx.article?.source)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_ctx.article?.source)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("iframe", {
                          src: _ctx.getYoutubeUrl(_ctx.article?.source),
                          frameborder: "0",
                          allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                          allowfullscreen: ""
                        }, null, 8, _hoisted_10)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("ul", _hoisted_11, [
              _createElementVNode("li", null, [
                _hoisted_12,
                _createVNode(_component_router_link, { to: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode("La Poste du Bénin")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _hoisted_13,
                _createTextVNode(_toDisplayString(_ctx.format_Date(_ctx.article?.datePublication)), 1)
              ]),
              _hoisted_14
            ]),
            _createElementVNode("h2", null, _toDisplayString(_ctx.article?.titre), 1),
            _createElementVNode("h5", null, _toDisplayString(_ctx.article?.sousTitre), 1),
            _createElementVNode("div", {
              class: "post-para",
              innerHTML: _ctx.article?.contenu
            }, null, 8, _hoisted_15),
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articlees, (articlee, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-xl-4 col-lg-6 col-md-6",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("a", {
                      href: _ctx.getUrlApiForFiles(articlee.type),
                      target: "_blank",
                      "data-lightbox": "gallery"
                    }, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("img", {
                          src: _ctx.getUrlApiForFiles(articlee.type),
                          alt: "Image"
                        }, null, 8, _hoisted_20)
                      ])
                    ], 8, _hoisted_18)
                  ])
                ]))
              }), 128))
            ]),
            _hoisted_21
          ]),
          (_ctx.article?.articletags.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _hoisted_26,
                      _createElementVNode("ul", _hoisted_27, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.article?.articletags, (articletag) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: articletag.id
                          }, [
                            _createVNode(_component_router_link, { to: "" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(articletag.tag.nom), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createTextVNode(", ")
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _hoisted_28
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_component_ViewArticleSidebar)
        ])
      ])
    ])
  ]))
}